<template>
  <div>
    <MainIntro />
    <CqcReport />
    <OurServices />
    <ContactView />
  </div>
</template>
<script>
import MainIntro from "./MainIntro";
import CqcReport from "./CqcReport";
import OurServices from "./OurServices";
import ContactView from "./ContactView";
export default {
  components: {
    MainIntro,
    CqcReport,
    OurServices,
    ContactView,
  },
};
</script>
